import styled from 'styled-components';

export const AboutContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;
    padding: 30px 0; 
`;

export const Title = styled.h1`
    color: #8f3d8f;
    margin: 30px 0;
`;

export const TextContainer = styled.div`
    width: 60%;
    text-align: justify;
`;